import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <h1>{{ 'general.Notification log' | translate }}</h1>
        <div class="alert alert-plain ng-scope">
            <p>{{ 'manage.notification_log_explanation_message' | translate }}</p>
        </div>
        <manage-logs-notificationlog-filter list="vm.list" default-filter="vm.defaultFilter"></manage-logs-notificationlog-filter>
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
            <pagination-tools list="vm.list"></pagination-tools>
            <table
                class="data01"
                datatable
                dt-options="vm.DATATABLES"
                >
                <thead>
                    <tr>
                        <th>{{ 'notificationLog.Sent out' | translate }}</th>
                        <th>{{ 'notificationLog.Employee' | translate }}</th>
                        <th>{{ 'notificationLog.Recipient email' | translate }}</th>
                        <!-- Channel is shown again once there are other channels besides e-mail
                        <th>{{ 'notificationLog.Channel' | translate }}</th>
                        -->
                        <th>{{ 'notificationLog.Status' | translate }}</th>
                        <th ng-if="vm.PrivilegeService.isSuperAdmin()">{{ 'notificationLog.Reason' | translate }}</th>
                        <th class="nosort">&nbsp;</th>
                        <th class="none">{{ 'notificationLog.Calendar file was included' | translate }}:</th>
                        <th class="none">{{ 'notificationLog.Notification text' | translate }}:</th>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in vm.list.items">
                        <td>{{ vm.moment(item.timestamp * 1000).format('DD.MM.YYYY HH:mm:ss') }}</td>
                        <td>{{ item.user.displayName }}</td>
                        <td>{{ item.recipient }}</td>
                        <!-- Channel is shown again once there are other channels besides e-mail
                        <td>{{ item.channelLabel }}</td>
                        -->
                        <td>{{ ('notificationLog.' + item.statusLabel) | translate }}</td>
                        <td ng-if="vm.PrivilegeService.isSuperAdmin()">{{ item.reason }}</td>
                        <td class="actions">
                            <a ng-if="item.canResend" class="btn discrete" ng-click="vm.resendAction(item)">
                                {{ 'notificationLog.Resend notification' | translate }}
                            </a>
                        </td>
                        <td>
                            <div ng-if="item.isIcalIncluded">{{ 'general.Yes' | translate }}</div>
                            <div ng-if="!item.isIcalIncluded">{{ 'general.No' | translate }}</div>
                        </td>
                        <td>
                            <div ng-if="item.notificationText" ng-bind-html="item.notificationText"></div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination ng-if="vm.list.items.length" list="vm.list"></pagination>
        </div>
    `
})
export default class {
    constructor ($state, $translate, moment, toastr, ListFactory, NotificationLogResource, NotificationResource, DATATABLES, ModalService,
                 PrivilegeService) {
        this.$state = $state;
        this.$translate = $translate;
        this.moment = moment;
        this.toastr = toastr;
        this.DATATABLES = DATATABLES;
        this.defaultFilter = {};
        this.list = ListFactory.createWithPagination(NotificationLogResource.query.bind(NotificationLogResource));
        // we set perPage via pagination to avoid resetting it when using filter
        this.list.pagination.perPage = 20;
        this.NotificationResource = NotificationResource;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
    }

    resendAction (notificationLog) {
        this.ModalService.confirm(
            this.$translate.instant('notificationLog.Are you sure you wish to resend this notification?'),
            'medium'
        ).then(() => {
            this.NotificationResource.publish(notificationLog).$promise
                .then(() => {
                    this.toastr.success(this.$translate.instant('general.Notification is sent'));
                })
                .catch(() => {
                    this.toastr.error(this.$translate.instant('general.Item has been deleted. No actions can be performed'));
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/logs/notificationlog/index.js